import React from "react";
import { Button, TextField, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { approveRejectMultipleCG, approveRejectMultiplePG, getCustomerGroups, getProductGroups, setState } from "./cgpgSlice";

const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 400,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 2,
   borderRadius: 1,
};

export default function RejectSelectedModal() {
   const dispatch = useDispatch();
   const {
      rejectMultiModalOpen,
      rejectSelectedComment,
      selectedRows,
      scenariosForApproval,
      selectedPeriod,

      selectedCountryID,
      selectedGroupStatus,
      selectedView,

      productGroups, 
      customerGroups,
   } = useSelector((store) => store.cgpgApproval);

   function handleClose() {
      dispatch(setState("rejectMultiModalOpen", false));
   }

   function setComment(event) {
      const comment = event.target.value;
      dispatch(setState("rejectSelectedComment", comment));
   }

   function search() {
      dispatch(setState("productGroupsTable", null));
      dispatch(setState("customerGroupsTable", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("customerGroups", null));

		const obj = {
			logedUser: JSON.parse(localStorage.getItem("data")),
			countryId: selectedCountryID,
			groupStatus: selectedGroupStatus,
			period: selectedPeriod,
			searchText: "",
		};

		if (selectedView === "Product Group") {
			dispatch(getProductGroups(obj));
		} else {
			dispatch(getCustomerGroups(obj));
		}
	}

   function rejectSelected() {
      handleClose();

      let itemList = [];
      for (let i = 0; i < selectedRows.length; ++i) {
         const id = selectedRows[i];

         let item = null;

         if(selectedView === "Product Group") {
            item = productGroups.find((pg) => pg.productGroupID === id);
         }
         else {
            item = customerGroups.find((cg) => cg.customerGroupID === id);
         }
         item = {
            ...item,
            comments: rejectSelectedComment,
            isApprove: 0,
         };

         itemList.push(item);
      }
      console.log("Approve_CGPG_ApproveRejectSelected", itemList);

      if(selectedView === "Product Group") {
         dispatch(approveRejectMultiplePG(itemList));
      }
      else {
         dispatch(approveRejectMultipleCG(itemList));
      }
      search();
   }

   return (
      <Box>
         <Modal open={rejectMultiModalOpen} onClose={handleClose}>
            <Box sx={style}>
               <Typography variant="subtitle2">Comments</Typography>
               <TextField className={'fullHeight'}
                  sx={{ width: 1000 }}
                  value={rejectSelectedComment}
                  onChange={setComment}
               />
               <br />
               <Button
                  sx={{
                     bgcolor: "blue.main",
                     color: "white.main",
                     textTransform: "none",
                     mt: 1,
                     "&:hover": {
                        bgcolor: "skyBlue.main",
                        color: "black.main",
                     },
                  }}
                  onClick={rejectSelected}
               >
                  Reject
               </Button>
            </Box>
         </Modal>
      </Box>
   );
}
